import IValidateRequest from '../entities/ValidateRequest'
import { IUserRepository } from '../repositories/IUserRepository'

export interface IValidateCnpj {
  execute(params: IValidateRequest): Promise<void>
}

export default class ValidateCnpjImpl implements IValidateCnpj {
  constructor(private readonly userRepository: IUserRepository) {}

  public async execute(params: IValidateRequest): Promise<void> {
    await this.userRepository.validate(params)
  }
}
